import React from "react";
import '../index.css';
import CanonicalTag from "./CanonicalTag";
import { Helmet } from "react-helmet";
import careerOrientedImage from '../assets/WhyUs/career oriented images.jpeg';
import quaility from '../assets/WhyUs/quality.png';
import client from '../assets/WhyUs/client-satisfaction.png';
import team from '../assets/WhyUs/expert team.png';
import Commitment  from '../assets/WhyUs/commitement.png';
import cost from '../assets/WhyUs/Costeffective.png';
const Whyus = () => {
    return (
<>
 {/* SEO Meta & Canonical */}

    <Helmet>
  <title>Why Choose Valerion Impex | Cement Machinery Parts Manufacturer</title>

  <meta
    name="description"
    content="Discover why Valerion Impex is a trusted manufacturer and supplier of cement machinery parts. We deliver premium quality, precision engineering, competitive pricing, timely delivery and reliable customer support for cement plants worldwide."
  />

  <meta
    name="keywords"
    content="why choose Valerion Impex, cement machinery parts manufacturer, cement plant equipment supplier, industrial machinery manufacturer, cement plant spare parts, rotary kiln parts supplier, cement equipment manufacturer India, reliable cement machinery supplier, precision engineered parts, cement industry solutions, Valerion Impex"
  />
</Helmet>

      <CanonicalTag url="https://www.cementmachineryparts.in/why-us" />
<div className="carrer-img-container">
<img src={careerOrientedImage} alt="careerOrientedImage" className="img-fluid career-img"/>
 <h1 className="career-text">Why Us</h1>
</div>
<div className="container text fs-4 mt-1 ">
    <p>Valerion Impex Pvt Limited, Indian based manufacturers & Exporters is a market leader and innovator in all type of cement equipment’s for all Cement Industries.</p>
    <p>This is a great opportunity to work with a growing company that understands the value of truly supporting their independent representative network, please review our brochure.</p>
    <p>Valerion Impex Pvt Ltd products are approved and duly accepted by actual Cement industries end users in Gulf, African and Middle East countries. Valerion products have a distinct advantage over other competitive products in the market.</p>
</div>
<div className="container py-4">
  <div className="row justify-content-center text-center g-4">
    <div className="col-6 col-sm-4 col-lg-2">
      <img src={quaility} alt="Excellent Quality" className="img-fluid mb-2" />
      <p>Excellent Quality</p>
    </div>
    <div className="col-6 col-sm-4 col-lg-2">
      <img src={client} alt="Client Satisfaction" className="img-fluid mb-2" />
      <p>Client Satisfaction</p>
    </div>
    <div className="col-6 col-sm-4 col-lg-2">
      <img src={team} alt="Expert Team" className="img-fluid mb-2" />
      <p>Expert Team</p>
    </div>
    <div className="col-6 col-sm-4 col-lg-2">
      <img src={Commitment} alt="Commitment" className="img-fluid mb-2" />
      <p>Commitment</p>
    </div>
    <div className="col-6 col-sm-4 col-lg-2">
      <img src={cost} alt="Cost Effective" className="img-fluid mb-2" />
      <p>Cost Effective</p>
    </div>
  </div>
</div>

</>
    );
};
export default Whyus;